'use client'

import React, { useEffect } from 'react'
import { useSearchParams } from 'next/navigation'
import Cookies from 'js-cookie'

import { CommonCookie } from '~/app/common/enums'

const CheckSession: React.FC = () => {
  const searchParams = useSearchParams()
  const checkSessionQueryParam = searchParams?.get('checkSession')

  const hasCheckedSession = Cookies.get(CommonCookie.SilentLoginAttempted)

  useEffect(() => {
    if (!hasCheckedSession && checkSessionQueryParam) {
      const returnUrl = new URL(window.location.href)
      const params = new URLSearchParams(returnUrl.search)

      params.delete('checkSession')
      params.append(CommonCookie.SilentLoginAttempted, 'true')

      returnUrl.search = params.toString()

      fetch(`/api/auth/login?returnUrl=${returnUrl?.toString()}`)
        .then((response) => response.json())
        .then((response) => {
          if (response?.authRedirect?.url) {
            // [Workaround] ⚠️ Safari (and some other browsers) may cancel RSC(React Server Components) payload fetches
            // if a navigation (like window.location.href) is triggered too quickly after page load.
            // Wrapping this in setTimeout gives RSC requests a moment to settle,
            // preventing "Failed to fetch RSC payload" warnings and full reloads.
            setTimeout(() => {
              window.location.href = response.authRedirect.url
            }, 1000)
          }
        })
        .catch((error) => {
          console.error('Login request failed :', error)
        })
    }
  }, [checkSessionQueryParam, hasCheckedSession])

  return <></>
}

export { CheckSession }
